import { useEffect } from 'react';
import { useColDividers, useRowDividers } from '~/features/grid/selectors';
import { useStore } from '~/store';

/**
 * Drop out-of-range clip refs whenever the grid (uniform mode) or blob list
 * (pin mode) shrinks. No auto-fill — clips are created explicitly from the
 * canvas selection.
 */
export function useReconcileClips(): void {
  const ensureClipsForGrid = useStore((s) => s.ensureClipsForGrid);
  const ensureClipsForBlobs = useStore((s) => s.ensureClipsForBlobs);
  const rowDividers = useRowDividers();
  const colDividers = useColDividers();
  const blobs = useStore((s) => s.pin.blobs);
  const rowCount = Math.max(0, rowDividers.length - 1);
  const colCount = Math.max(0, colDividers.length - 1);
  const blobCount = blobs?.length ?? 0;

  useEffect(() => {
    ensureClipsForGrid(rowCount, colCount);
  }, [ensureClipsForGrid, rowCount, colCount]);

  useEffect(() => {
    if (!blobs) return;
    ensureClipsForBlobs(blobCount);
  }, [ensureClipsForBlobs, blobs, blobCount]);
}
